<script setup lang="ts">
/**
 * The scene of the empty states of Tabel, algemene standaard: the scene VTable draws when a screen gives no scene of its own (illustration set, board AutomationsOther).
 * VEmptyIllustration draws the ground and the badge of the state around it.
 */
</script>

<template>
  <g data-scene="generic-table">
    <rect
      x="36"
      y="46"
      width="128"
      height="72"
      rx="6"
      fill="#FFFFFF"
      stroke="#BDBDBD"
      stroke-width="1.6"
      stroke-linejoin="round"
    />
    <path d="M36 52a6 6 0 0 1 6-6h116a6 6 0 0 1 6 6v8H36z" fill="#EEEEEE" />
    <path d="M36 60h128" stroke="#BDBDBD" stroke-width="1.6" />
    <rect
      x="44"
      y="50"
      width="24"
      height="5"
      rx="2.5"
      fill="#BDBDBD"
    />
    <rect
      x="84"
      y="50"
      width="20"
      height="5"
      rx="2.5"
      fill="#BDBDBD"
    />
    <rect
      x="122"
      y="50"
      width="22"
      height="5"
      rx="2.5"
      fill="#BDBDBD"
    />
    <rect
      x="44"
      y="68"
      width="112"
      height="10"
      rx="3"
      fill="none"
      stroke="#E0E0E0"
      stroke-width="1.4"
      stroke-dasharray="3 3"
    />
    <rect
      x="44"
      y="84"
      width="112"
      height="10"
      rx="3"
      fill="none"
      stroke="#E0E0E0"
      stroke-width="1.4"
      stroke-dasharray="3 3"
    />
    <rect
      x="44"
      y="100"
      width="112"
      height="10"
      rx="3"
      fill="none"
      stroke="#E0E0E0"
      stroke-width="1.4"
      stroke-dasharray="3 3"
    />
    <circle cx="100" cy="105" r="3" fill="#C8E6C9" />
  </g>
</template>
